import AdAnnotations from "../react/annotations/AdAnnotations";
import ResolvedAnnotationsHandler from "../components/ResolvedAnnotationsHandler";
import N2StylesModal from "../components/N2StylesModal";

export default class ErPlusJobsWizard {
  constructor(params) {
    this.params = params;
  }

  unload() {
    AdAnnotations.unload();
  }

  show() {
    if (this.params.id === "work_on_ad") {
      this.setupAnnotations();
    }
    this.finalText = $("#final-text");
    this.finalText.text(this.finalStepText());
    this.bindLastStepModal();
    this.bindFinalStepTextHandler();
  }

  setupAnnotations() {
    // unload here in event user pushed back in browser
    AdAnnotations.unload();
    if ($("img.js-annotation-boundry").length) {
      const img = new Image();
      img.src = $("img.js-annotation-boundry")[0].src;
      img.onload = () => {
        this.adAnnotations = AdAnnotations.init();
        this.setupResolvedHandler();
      };
    } else {
      this.adAnnotations = AdAnnotations.init();
      this.setupResolvedHandler();
    }
  }

  setupResolvedHandler() {
    const currAnno = $.grep(this.adAnnotations.annotations,
      anno => anno.id === this.params.currentAnnotation)[0] || {};

    (() => new ResolvedAnnotationsHandler({ resolved: currAnno.resolved }))();
  }

  bindLastStepModal() {
    N2.handle("click", ".js-no-last-step-available", (e) => {
      const url = $(e.currentTarget).data("url");
      const modal = $(e.currentTarget).data("modal");
      const finishPath = $(e.currentTarget).data("finishPath");
      $.get(url, { format: "json" }, (data) => {
        if (data.valid) {
          window.location = finishPath;
        } else {
          $(".js-error-message").text(data.message);
          (() => new N2StylesModal(modal))();
        }
      });
    });
  }

  workOnText() {
    return this.adAnnotations.annotations.every(a => a.resolved) ? "Approve" : "Submit to Design";
  }

  finishAdText() {
    const status = $("#er_plus_job_status")[0].value;
    return (status === "approved") ? "Approve" : "Submit to Design";
  }

  finalStepText() {
    if (this.params.id === "finish_ad") { return this.finishAdText(); }

    return this.workOnText();
  }

  bindFinalStepTextHandler() {
    N2.handle("click", "body", () => {
      this.finalText.text(this.finalStepText());
    });
  }
}
